import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-notification[msgType][msgHeading]',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
  //msgDescription provides the message description
  msgDescription: string;

  //msgHeading provides the message Heading
  msgHeading: string;

  //type provides the message type
  msgType: string;

  constructor(
    public snackBarRef: MatSnackBarRef<NotificationComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {
    this.msgType = data.msgType;
    this.msgHeading = data.msgHeading;
    this.msgDescription = data.msgDescription;
  }

  /**
   * GetIcon method is used to get matIcon name
   *
   * @returns {string} respective matIcon based on the snackType,
   * which are check, danger, error_outline, warn, info.
   */
  get getIcon() {
    switch (this.msgType) {
      case 'success':
        return 'check';
      case 'failure':
        return 'error_outline';
      case 'warning':
        return 'error_outline';
      case 'info':
        return 'info_outline';
      default:
        return 'check';
    }
  }
}
